/**
 * IST business dates for the UI.
 *
 * `new Date().toISOString().split('T')[0]` is the UTC day — between 00:00 and
 * 05:30 IST it is still "yesterday", so default date filters, "today" pre-fills
 * and max-date guards were a day behind every morning. The backend works in IST
 * (policy C6); so does this.
 */
const IST = 'Asia/Kolkata';

// en-CA formats as YYYY-MM-DD, which is what the date inputs and the API expect.
const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: IST, year: 'numeric', month: '2-digit', day: '2-digit',
});

/** YYYY-MM-DD of `d` (Date | parseable value) on the IST calendar; '' when invalid. */
export const toISTDateString = (d) => {
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '';
  return formatter.format(date);
};

/** Today's YYYY-MM-DD in IST. */
export const todayIST = () => toISTDateString(new Date());
